/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationResponsiblePersonRequest
 */
export interface ApplicationResponsiblePersonRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponsiblePersonRequest
     */
    userId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponsiblePersonRequest
     */
    isApplicationAdministrator?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponsiblePersonRequest
     */
    canManageAccessRequestsForApplication?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponsiblePersonRequest
     */
    canAppointExternalApproversForApplication?: boolean;
}

/**
 * Check if a given object implements the ApplicationResponsiblePersonRequest interface.
 */
export function instanceOfApplicationResponsiblePersonRequest(value: object): value is ApplicationResponsiblePersonRequest {
    return true;
}

export function ApplicationResponsiblePersonRequestFromJSON(json: any): ApplicationResponsiblePersonRequest {
    return ApplicationResponsiblePersonRequestFromJSONTyped(json, false);
}

export function ApplicationResponsiblePersonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponsiblePersonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'isApplicationAdministrator': json['isApplicationAdministrator'] == null ? undefined : json['isApplicationAdministrator'],
        'canManageAccessRequestsForApplication': json['canManageAccessRequestsForApplication'] == null ? undefined : json['canManageAccessRequestsForApplication'],
        'canAppointExternalApproversForApplication': json['canAppointExternalApproversForApplication'] == null ? undefined : json['canAppointExternalApproversForApplication'],
    };
}

export function ApplicationResponsiblePersonRequestToJSON(json: any): ApplicationResponsiblePersonRequest {
    return ApplicationResponsiblePersonRequestToJSONTyped(json, false);
}

export function ApplicationResponsiblePersonRequestToJSONTyped(value?: ApplicationResponsiblePersonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'isApplicationAdministrator': value['isApplicationAdministrator'],
        'canManageAccessRequestsForApplication': value['canManageAccessRequestsForApplication'],
        'canAppointExternalApproversForApplication': value['canAppointExternalApproversForApplication'],
    };
}

